import React, { useState } from 'react';
import { Lightbulb, BarChart2, Rocket, ChevronDown, ChevronUp } from 'lucide-react';
export const Services = () => {
  const [activeTab, setActiveTab] = useState('ideas');
  const toggleTab = (tab: string) => {
    setActiveTab(tab === activeTab ? '' : tab);
  };
  return <section id="services" className="py-16 md:py-24 bg-gray-50" data-id="element-272">
      <div className="container mx-auto px-4" data-id="element-273">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-274">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-275">
            Our Services
          </h2>
          <p className="text-lg text-gray-600" data-id="element-276">
            We approach every engagement through our three key pillars, tailored
            to meet the unique needs of businesses and individuals alike.
          </p>
        </div>
        {/* Desktop View */}
        <div className="hidden md:grid grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-277">
          <div className="bg-white p-8 rounded-lg shadow-md border-t-4 border-amber-500" data-id="element-278">
            <div className="flex items-center mb-6" data-id="element-279">
              <div className="bg-amber-500 rounded-full w-12 h-12 flex items-center justify-center mr-4" data-id="element-280">
                <Lightbulb className="text-white" size={24} data-id="element-281" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-282">IDEAS</h3>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-283">
              Transforming visions into well-defined concepts ready for
              strategic implementation.
            </p>
            <ul className="space-y-3 text-gray-700" data-id="element-284">
              <li className="flex items-start" data-id="element-285">
                <span className="text-amber-500 mr-2" data-id="element-286">•</span>
                <span data-id="element-287">Ideation Workshops & Innovation Labs</span>
              </li>
              <li className="flex items-start" data-id="element-288">
                <span className="text-amber-500 mr-2" data-id="element-289">•</span>
                <span data-id="element-290">Market Research & Opportunity Analysis</span>
              </li>
              <li className="flex items-start" data-id="element-291">
                <span className="text-amber-500 mr-2" data-id="element-292">•</span>
                <span data-id="element-293">Concept Development & Refinement</span>
              </li>
              <li className="flex items-start" data-id="element-294">
                <span className="text-amber-500 mr-2" data-id="element-295">•</span>
                <span data-id="element-296">Brand Identity Development</span>
              </li>
              <li className="flex items-start" data-id="element-297">
                <span className="text-amber-500 mr-2" data-id="element-298">•</span>
                <span data-id="element-299">Value Proposition Design</span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md border-t-4 border-blue-700" data-id="element-300">
            <div className="flex items-center mb-6" data-id="element-301">
              <div className="bg-blue-700 rounded-full w-12 h-12 flex items-center justify-center mr-4" data-id="element-302">
                <BarChart2 className="text-white" size={24} data-id="element-303" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-304">STRATEGY</h3>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-305">
              Creating comprehensive roadmaps that align vision with actionable
              plans for success.
            </p>
            <ul className="space-y-3 text-gray-700" data-id="element-306">
              <li className="flex items-start" data-id="element-307">
                <span className="text-blue-700 mr-2" data-id="element-308">•</span>
                <span data-id="element-309">Business Model Development</span>
              </li>
              <li className="flex items-start" data-id="element-310">
                <span className="text-blue-700 mr-2" data-id="element-311">•</span>
                <span data-id="element-312">Strategic Planning & Roadmapping</span>
              </li>
              <li className="flex items-start" data-id="element-313">
                <span className="text-blue-700 mr-2" data-id="element-314">•</span>
                <span data-id="element-315">Competitive Analysis & Positioning</span>
              </li>
              <li className="flex items-start" data-id="element-316">
                <span className="text-blue-700 mr-2" data-id="element-317">•</span>
                <span data-id="element-318">Growth & Scaling Strategies</span>
              </li>
              <li className="flex items-start" data-id="element-319">
                <span className="text-blue-700 mr-2" data-id="element-320">•</span>
                <span data-id="element-321">Financial Modeling & Fundraising Strategy</span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md border-t-4 border-green-600" data-id="element-322">
            <div className="flex items-center mb-6" data-id="element-323">
              <div className="bg-green-600 rounded-full w-12 h-12 flex items-center justify-center mr-4" data-id="element-324">
                <Rocket className="text-white" size={24} data-id="element-325" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-326">EXECUTION</h3>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-327">
              Bringing strategies to life through disciplined implementation and
              continuous optimization.
            </p>
            <ul className="space-y-3 text-gray-700" data-id="element-328">
              <li className="flex items-start" data-id="element-329">
                <span className="text-green-600 mr-2" data-id="element-330">•</span>
                <span data-id="element-331">Project Management & Implementation</span>
              </li>
              <li className="flex items-start" data-id="element-332">
                <span className="text-green-600 mr-2" data-id="element-333">•</span>
                <span data-id="element-334">Team Building & Organizational Development</span>
              </li>
              <li className="flex items-start" data-id="element-335">
                <span className="text-green-600 mr-2" data-id="element-336">•</span>
                <span data-id="element-337">Marketing Campaign Execution</span>
              </li>
              <li className="flex items-start" data-id="element-338">
                <span className="text-green-600 mr-2" data-id="element-339">•</span>
                <span data-id="element-340">Performance Tracking & Optimization</span>
              </li>
              <li className="flex items-start" data-id="element-341">
                <span className="text-green-600 mr-2" data-id="element-342">•</span>
                <span data-id="element-343">Process Implementation & Automation</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Mobile View - Accordion */}
        <div className="md:hidden space-y-4 max-w-lg mx-auto" data-id="element-344">
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-345">
            <button className="w-full px-6 py-4 flex justify-between items-center border-l-4 border-amber-500" onClick={() => toggleTab('ideas')} data-id="element-346">
              <div className="flex items-center" data-id="element-347">
                <div className="bg-amber-500 rounded-full w-10 h-10 flex items-center justify-center mr-3" data-id="element-348">
                  <Lightbulb className="text-white" size={20} data-id="element-349" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-350">IDEAS</h3>
              </div>
              {activeTab === 'ideas' ? <ChevronUp size={20} data-id="element-351" /> : <ChevronDown size={20} data-id="element-352" />}
            </button>
            {activeTab === 'ideas' && <div className="px-6 py-4 border-t" data-id="element-353">
                <p className="text-gray-600 mb-4" data-id="element-354">
                  Transforming visions into well-defined concepts ready for
                  strategic implementation.
                </p>
                <ul className="space-y-2 text-gray-700" data-id="element-355">
                  <li className="flex items-start" data-id="element-356">
                    <span className="text-amber-500 mr-2" data-id="element-357">•</span>
                    <span data-id="element-358">Ideation Workshops & Innovation Labs</span>
                  </li>
                  <li className="flex items-start" data-id="element-359">
                    <span className="text-amber-500 mr-2" data-id="element-360">•</span>
                    <span data-id="element-361">Market Research & Opportunity Analysis</span>
                  </li>
                  <li className="flex items-start" data-id="element-362">
                    <span className="text-amber-500 mr-2" data-id="element-363">•</span>
                    <span data-id="element-364">Concept Development & Refinement</span>
                  </li>
                  <li className="flex items-start" data-id="element-365">
                    <span className="text-amber-500 mr-2" data-id="element-366">•</span>
                    <span data-id="element-367">Brand Identity Development</span>
                  </li>
                  <li className="flex items-start" data-id="element-368">
                    <span className="text-amber-500 mr-2" data-id="element-369">•</span>
                    <span data-id="element-370">Value Proposition Design</span>
                  </li>
                </ul>
              </div>}
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-371">
            <button className="w-full px-6 py-4 flex justify-between items-center border-l-4 border-blue-700" onClick={() => toggleTab('strategy')} data-id="element-372">
              <div className="flex items-center" data-id="element-373">
                <div className="bg-blue-700 rounded-full w-10 h-10 flex items-center justify-center mr-3" data-id="element-374">
                  <BarChart2 className="text-white" size={20} data-id="element-375" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-376">STRATEGY</h3>
              </div>
              {activeTab === 'strategy' ? <ChevronUp size={20} data-id="element-377" /> : <ChevronDown size={20} data-id="element-378" />}
            </button>
            {activeTab === 'strategy' && <div className="px-6 py-4 border-t" data-id="element-379">
                <p className="text-gray-600 mb-4" data-id="element-380">
                  Creating comprehensive roadmaps that align vision with
                  actionable plans for success.
                </p>
                <ul className="space-y-2 text-gray-700" data-id="element-381">
                  <li className="flex items-start" data-id="element-382">
                    <span className="text-blue-700 mr-2" data-id="element-383">•</span>
                    <span data-id="element-384">Business Model Development</span>
                  </li>
                  <li className="flex items-start" data-id="element-385">
                    <span className="text-blue-700 mr-2" data-id="element-386">•</span>
                    <span data-id="element-387">Strategic Planning & Roadmapping</span>
                  </li>
                  <li className="flex items-start" data-id="element-388">
                    <span className="text-blue-700 mr-2" data-id="element-389">•</span>
                    <span data-id="element-390">Competitive Analysis & Positioning</span>
                  </li>
                  <li className="flex items-start" data-id="element-391">
                    <span className="text-blue-700 mr-2" data-id="element-392">•</span>
                    <span data-id="element-393">Growth & Scaling Strategies</span>
                  </li>
                  <li className="flex items-start" data-id="element-394">
                    <span className="text-blue-700 mr-2" data-id="element-395">•</span>
                    <span data-id="element-396">Financial Modeling & Fundraising Strategy</span>
                  </li>
                </ul>
              </div>}
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-397">
            <button className="w-full px-6 py-4 flex justify-between items-center border-l-4 border-green-600" onClick={() => toggleTab('execution')} data-id="element-398">
              <div className="flex items-center" data-id="element-399">
                <div className="bg-green-600 rounded-full w-10 h-10 flex items-center justify-center mr-3" data-id="element-400">
                  <Rocket className="text-white" size={20} data-id="element-401" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-402">EXECUTION</h3>
              </div>
              {activeTab === 'execution' ? <ChevronUp size={20} data-id="element-403" /> : <ChevronDown size={20} data-id="element-404" />}
            </button>
            {activeTab === 'execution' && <div className="px-6 py-4 border-t" data-id="element-405">
                <p className="text-gray-600 mb-4" data-id="element-406">
                  Bringing strategies to life through disciplined implementation
                  and continuous optimization.
                </p>
                <ul className="space-y-2 text-gray-700" data-id="element-407">
                  <li className="flex items-start" data-id="element-408">
                    <span className="text-green-600 mr-2" data-id="element-409">•</span>
                    <span data-id="element-410">Project Management & Implementation</span>
                  </li>
                  <li className="flex items-start" data-id="element-411">
                    <span className="text-green-600 mr-2" data-id="element-412">•</span>
                    <span data-id="element-413">Team Building & Organizational Development</span>
                  </li>
                  <li className="flex items-start" data-id="element-414">
                    <span className="text-green-600 mr-2" data-id="element-415">•</span>
                    <span data-id="element-416">Marketing Campaign Execution</span>
                  </li>
                  <li className="flex items-start" data-id="element-417">
                    <span className="text-green-600 mr-2" data-id="element-418">•</span>
                    <span data-id="element-419">Performance Tracking & Optimization</span>
                  </li>
                  <li className="flex items-start" data-id="element-420">
                    <span className="text-green-600 mr-2" data-id="element-421">•</span>
                    <span data-id="element-422">Process Implementation & Automation</span>
                  </li>
                </ul>
              </div>}
          </div>
        </div>
      </div>
    </section>;
};